import { VehicleSection } from '@/components/VehicleSection/VehicleSection';
import { useAppConstantsContext } from '@/context/AppConstants';
import { HowItWorksCTA } from '@/reports/shared/ReportSection/components';
import { AutomobileImpounds } from '@/reports/types/vehicles';
import { Text, Table, useTheme } from '@/theme/index';

export interface VehicleImpoundsProps {
  /** A list of all impound data */
  vehicleImpoundList: AutomobileImpounds;
}

function HowItWorksCTAContent() {
  const {
    data: { brandName },
  } = useAppConstantsContext();

  return (
    <Text
      variant="body2"
      fontSize="0.9rem"
      color={(theme) => theme.palette.grey[800]}
    >
      In most cases, Impound data is reported to us that day or the day after
      the event. This data covers jurisdictions in the US that report data to{' '}
      {brandName}. In most cases, it includes the date it was reported and the
      state.
    </Text>
  );
}

/** This renders a table view of impound data */
export const VehicleImpounds: React.FC<VehicleImpoundsProps> = ({
  vehicleImpoundList,
}) => {
  const theme = useTheme();

  const header = [
    <Text variant="h5" sx={{ p: 1, m: 0 }}>
      Date
    </Text>,
    <Text variant="h5" sx={{ p: 1, m: 0 }}>
      State
    </Text>,
  ];
  const modifiedImpoundList = vehicleImpoundList?.map((impound) => {
    const date = impound?.date?.full || '';
    const state = impound?.state || '';

    return [
      <Text variant="body2" sx={{ p: theme.spacing(1) }}>
        {date}
      </Text>,
      <Text variant="body2" sx={{ p: theme.spacing(1) }}>
        {state}
      </Text>,
    ];
  });

  const modifiedMobileSalesList = vehicleImpoundList?.map((impound) => {
    const date = impound?.date?.full || '';
    const state = impound?.state || '';

    return (
      <Table
        className="striped styleless-header mobile"
        headers={[
          <Text
            variant="h5"
            sx={{
              p: 0,
              m: 0,
            }}
          >
            {date}
          </Text>,
        ]}
        rows={[['State', state]]}
      />
    );
  });

  return (
    <VehicleSection
      headers={header}
      tableData={modifiedImpoundList}
      mobileTableData={modifiedMobileSalesList}
      reportSectionTitle="Impound records"
      emptySectionTitle="impound"
      sectionId="vehicle-impound"
      howItWorks={<HowItWorksCTA content={HowItWorksCTAContent()} />}
    />
  );
};
